export default {
  root: {
    padding: [0, 10],
  },
};
